<template>
  <v-container fluid grid-list-md>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!-- Dialog para confirmação de edição em uma situação em que já existe algum usuário editando a equipe -->
    <p-confirm text="Existem usuários realizando a edição desta equipe, poderá haver conflitos. Deseja continuar" :dialog="confirmEditDialog" @confirm="confirmEdit" @cancel="confirmEditDialog = false"></p-confirm>
    <!--Consult-->
    <!--Foi colocado o v-show para que não suma o filtro do PFilter-->
    <v-layout v-show="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.teams.icon')}}</v-icon>{{formTitle}}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field id="team_search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <p-filter
            ref="filter"
            :allItems="allItems"
            :entity="entity"
            :filterTypes="filterTypes"
            @customFilter="(res)=>{items=res}">
        </p-filter>
      </v-flex>
      <v-flex xs12>
        <v-data-table
            :headers="headers"
            :no-data-text="emptyTable"
            rows-per-page-text="Registros por página"
            :items="items"
            :search="search"
            class="elevation-1"
            item-key="id"
            :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
            :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>
              <v-avatar size="35" :color="props.item.color || '#cccccc'">
                <span :class="props.item.color ? 'avatar-letters' : 'avatar-no-color'"> {{ getFirstLetters(props.item.id_text) }} </span>
              </v-avatar>
            </td>
            <td @click="props.expanded = !props.expanded">{{ props.item.id_text }}</td>
            <!-- O campo ativo foi ocultado da tela de equipe. Posteriormente será retrabalhado e voltará a ser exibido
            <td @click="props.expanded = !props.expanded">
              <v-checkbox
                  readonly
                  v-model="props.item.active"
                  class="mx-auto"
              ></v-checkbox>
            </td> -->
            <td align="center">
              <v-tooltip bottom>
                <v-btn :id="'team_manage_btn_'+props.index" slot="activator" icon class="mx-0" @click="editItemProcess(props.item, 4)"
                       :disabled="!checkRespPermission(props.item) || !checkPermission(entity, 'manage')">
                  <v-icon color="teal">build</v-icon>
                </v-btn>
                <span>{{manageTooltipText}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn :id="'team_delete_btn_'+props.index" slot="activator" icon class="mx-0" @click="dialogDelete(props.item)"
                       :disabled="!checkRespPermission(props.item) || !checkPermission(entity, 'delete')">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>{{deleteTooltipText}}</span>
              </v-tooltip>
            </td>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card>
              <v-card-text class="grey lighten-2">
                <template>
                  <v-data-table
                      :headers="headersUser"
                      :items="props.item.users"
                      hide-actions
                      item-key="id"
                      no-data-text="Ainda não foram cadastrados registros de Participantes"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.user.id_text }}</td>
                      <td>
                        <v-checkbox
                            readonly
                            v-model="props.item.manager"
                            class="mx-auto"
                        ></v-checkbox>
                      </td>
                    </template>
                  </v-data-table>
                </template>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!-- ---------- -->
    <v-form v-if="dialog" v-model="valid" @keyup.native.ctrl.enter="view === 3 ? save(4) : saveEdit()" ref="form" class="mb-1">
      <v-layout wrap justify-center align-center>
        <v-flex :class="(view === 4) ? 'xs10' : 'xs12'">
          <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
        </v-flex>
        <v-flex v-if="view === 4" xs2 class="text-xs-right">
          <p-edit-btn fab @onClick="checkEditRoomEmpty(editedItem, 3)" :disabled="!checkPermission(entity, 'edit')">
          </p-edit-btn>
        </v-flex>
        <!--Management-->
        <v-container fluid grid-list-xs style="padding: 2px" v-if="view === 4">
          <div class="p-gradient">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="p-white p-white-icon">
                  <v-avatar class="icon" size="45" :color="editedItem.color || '#cccccc'">
                    <span :class="editedItem.color ? 'avatar-letters' : 'avatar-no-color'"> {{ getFirstLetters(editedItem.id_text) }} </span>
                  </v-avatar>
                  <div class="name">
                    <div class="p-label">{{translate('table.' + entity + '.field.id_text')}}</div>
                    <div class="p-content" style="word-break: break-all;">
                      {{editedItem.id_text}}
                    </div>
                  </div>
                </div>
              </v-flex>
              <!-- O campo ativo foi ocultado da tela de equipe. Posteriormente será retrabalhado e voltará a ser exibido
              <v-flex xs12 md2>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.active')}}</div>
                  <div class="p-content">{{translate('system.bollean')[editedItem.active]}}</div>
                </div>
              </v-flex> -->
            </v-layout>
          </div>
        </v-container>
        <!--Create Edit-->
        <v-container fluid grid-list-xs style="padding: 2px" v-else>
            <v-layout row justify-space-between wrap>
              <v-flex xs1>
                <swatches
                    id="team_color"
                    slot="activator"
                    v-model="editedItem.color"
                    colors="material-basic"
                    row-length="4"
                    shapes="circles"
                    popover-to="right"
                    :swatch-style="{ margin: '5px 5px' }"
                    show-fallback
                ></swatches>
              </v-flex>
              <v-flex xs12 md11>
                <v-text-field id="team_id_text" maxlength="190" counter="190"  :label="translate('table.' + entity + '.field.id_text')" ref="autofocus"
                              :rules="requiredRule(translate('table.' + entity + '.field.id_text'))"
                              v-model="editedItem.id_text"></v-text-field>
              </v-flex>
              <!-- O campo ativo foi ocultado da tela de equipe. Posteriormente será retrabalhado e voltará a ser exibido
              <v-flex xs12 md1>
                <v-switch :label="translate('table.' + entity + '.field.active')"
                          v-model="editedItem.active"></v-switch>
              </v-flex> -->
            </v-layout>
        </v-container>
      </v-layout>
    </v-form>
    <v-layout wrap justify-center align-center>
      <v-flex v-if="view == 4" xs12>
        <v-tabs dark color="cyan" v-model="tab" grow class="elevation-1">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab key="0" id="team_user_tab">
            {{this.translate('table.team_user.title')[1]}}
          </v-tab>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="0">
              <v-card>
                <v-card-text>
                  <team-user :team="editedItem"></team-user>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout v-if="view === 1"  class="fab-container" align-center>
      <v-tooltip top>
        <v-btn id="team_add_btn" slot="activator" color="primary" fab :disabled="!checkPlanAccess(entity, 'qtd', allItems.length)|| !checkPermission(entity, 'create')" @click="create">
          <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
        <span>{{createTooltipText}}</span>
      </v-tooltip>
    </v-layout>
    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn id="team_save_manage_btn" v-model="fab" slot="activator" fab color="primary" :loading="loading" dark @click="saveEdit()">
            <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
            <v-icon>{{this.translate('system.button.build.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_manage.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn id="team_save_close_btn" slot="activator" fab small color="accent" :loading="loading" @click="save()">
            <v-icon>{{this.translate('system.button.save_close.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_close.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn id="team_save_new_btn" slot="activator" fab small color="secondary" :disabled="!checkPlanAccess(entity, 'qtd', allItems.length + 1)" :loading="loading" @click="saveNew()">
            <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_new.title')}}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-tooltip top>
        <v-btn id="team_done_btn" slot="activator" v-if="view === 3" color="primary" :loading="loading" dark fab @click="save(4)">
          <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.done.title')}}</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn id="team_close_btn" slot="activator" fab small @click="close">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.close.title')}}</span>
      </v-tooltip>
    </v-layout>

  </v-container>
</template>

<style scoped>
  .avatar-no-color {
    color: #000;
    font-size: 1.2em;
    font-weight: normal !important;
  }

  .avatar-letters {
    color: #fff;
    font-size: 1.2em;
    font-weight: normal !important;
  }

  .p-white-icon {
    position: relative;
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.4em;
    left: 6px;
  }

  .name {
    padding-left: 70px;
  }

  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
</style>

<script>
  import socket from '../mixin/socket'
  import crud from '../mixin/crud'
  import rules from '../mixin/rules'
  import general from '../mixin/general'
  import TeamUser from './details/TeamUser'
  import PFilter from './shared/PFilter'
  import PEditBtn from './shared/PEditBtn'
  import PConfirm from './shared/PConfirm'
  import Swatches from 'vue-swatches'
  import access from '../mixin/access'
  import tooltip from '../mixin/tooltip'

  export default {
    mixins: [crud, rules, general, socket, access, tooltip],
    components: {TeamUser, PEditBtn, PFilter, PConfirm, Swatches},
    data: () => ({
      entity: 'teams',
      fab: null,
      accesses: [],
      tab: null,
      confirmEditDialog: false
    }),
    created () {
      this.$store.commit('loader/change_dialog', true)
      this.editedItem = {active: true, color: '', id_text: ''}
      this.defaultItem = {active: true, color: '', id_text: ''}
      this.initialize()
    },
    mounted () {
      this.$socket.emit('joinRoom', {room: this.socketRoom})
    },
    computed: {
      filterTypes: function () {
        return [
          {field: 'id_text', type: 'string'}
          // O campo ativo foi ocultado da tela de equipe. Posteriormente será retrabalhado e voltará a ser exibido
          // {field: 'active', type: 'boolean'}
        ]
      },
      headers: function () {
        return [
          {text: '', value: 'avatar', width: '5%', sortable: false},
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '90%'},
          // O campo ativo foi ocultado da tela de equipe. Posteriormente será retrabalhado e voltará a ser exibido
          // {text: this.translate('table.' + this.entity + '.field.active'), value: 'active'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      },
      headersUser: function () {
        return [
          {text: this.translate('table.team_user.field.user_id'), value: 'user.id_text'},
          {text: this.translate('table.team_user.field.manager'), value: 'manager', align: 'center'}
        ]
      }
    },
    methods: {
      afterInitialize (values) {
        this.redoFilter(values)
        this.checkQtdAccess(this.entity, this.allItems.length, false)
      },
      // * Este método é responsável por enviar um evento ao servidor para que verifique se a sala de edição está ocupada por algum usuário
      checkEditRoomEmpty (item, view) {
        this.$socket.emit('checkRoomEmpty', {room: `${this.socketRoom}_${item.id}`, user_id: this.$auth.user().id, view: view})
      },
      // * Método executado quando o usuário clica no botão "Confirmar" do dialog de confirmação para edição.
      confirmEdit () {
        this.editItem(this.editedItem, 3)
        this.confirmEditDialog = false
      },
      beforeEditItem (oldValues, view) {
        this.$socket.emit('joinRoom', {room: `${this.socketRoom}_${oldValues.id}${view === 3 ? '_edit' : ''}`, view: view})
      },
      afterInsert (newValues) {
        this.checkQtdAccess(this.entity, this.allItems.length)
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'addSocketItem',
          room: this.socketRoom
        })
      },
      afterDelete (oldValues) {
        // Evento enviado para excluir o registro para os usuários que estiverem na tela de consulta de equipes.
        this.$socket.emit('generalEvent', {
          data: oldValues,
          responseEvent: 'deleteSocketItem',
          room: this.socketRoom
        })
        // Evento que será enviado para todos os participantes que estiverem na tela de gerenciamento da equipe. Ele tem a função de mostrar o alerta
        // que irá solicitar o recarregamento da página pois não é possível editar uma equipe excluída.
        let item = {text: `A equipe "${oldValues.id_text}" foi excluída. Será necessário recarregar a página.`}
        this.$socket.emit('generalEvent', {
          data: item,
          responseEvent: 'reloadPage',
          room: `${this.socketRoom}_${oldValues.id}`
        })
        oldValues.users.forEach((val) => {
          this.$socket.emit('generalEvent', {
            data: {team_id: val.team_id, text: `A equipe ${oldValues.id_text} foi deletada, poderá haver conflito, recarregue a página para obter as mudanças`},
            responseEvent: 'socketSnackbar',
            room: `tasks${val.user_id}`
          })
        })
        // emição de socket para a tela de tarefas onde se a equipe é deletada o é notificado ou é recarregada a pagina
      },
      afterUpdate (newValues) {
        // Ao editar uma equipe, é necessário enviar dois eventos: 1 para atualizar as informações para as pessoas que estão na tela de gerenciamento e outro para as pessoas que estão na tela de consulta.
        // Evento enviado para atualizar as informações para as pessoas que estão na tela de gerenciamento de equipe

        // è tirado o users para não passar no Object.Assign e assim não perder o vinculo quando substitui o editedItem no evento "editSocketManagementDetails"
        delete newValues.users
        this.$socket.emit('generalEvent', {
          data: {values: newValues, entity: 'equipe'},
          responseEvent: 'editSocketManagementDetails',
          room: `${this.socketRoom}_${newValues.id}`
        })
        // Evento enviado para atualizar as informações para as pessoas que estão na tela de consulta de equipes
        // Verificar necessidade desse aqui...
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'editSocketItem',
          room: `${this.socketRoom}`
        })
        this.redoFilter(this.allItems)
      },
      checkRespPermission (team) {
        let hasPermission = false
        if (team.users) {
          let permissions = team.users.filter((res) => {
            return res.user_id === this.$auth.user().id && res.manager
          })[0]
          hasPermission = permissions || false
        }
        return hasPermission
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}`})
      // Sai das salas de gerenciamento e edição caso o usuário troque de tela enquanto ele está gerenciando/editando uma tarefa
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}`})
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}_edit`})
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Team.vue